<!--
    @论坛
-->
<template>
    <div class="forum">
        <SectionTitle title="意见汇总"></SectionTitle>
        <section class="forum-section">
            <div class="forum-section--btn">
                <el-button type="primary" size="small" style="width:160px;" @click="issueOpinion" v-if="ruleForm.status !== 3 ">发表意见</el-button>
            </div>
            <div class="section-main" v-if="tableData.length>0">
                <div class="section-main--item" v-for="item in tableData" :key="item.id">
                    <div class="main-item--left">
                        <div class="item-title">
                            <p>
                                <span class="item-title--name" :title="item.proposer">{{item.proposer}}</span>（{{item.deptName}}）
                                <span class="item-title--time">{{item.submitTime}}</span>
                            </p>
                            <div>
                                <template v-if="$route.query.type == '1'">
                                    <el-button type="text" v-if="!item.isTop && ruleForm.status !== 3" @click="topHandle(item)">置顶</el-button>
                                    <el-button type="text" v-if="item.isTop && ruleForm.status !== 3" @click="topNoHandle(item)">取消置顶</el-button>
                                </template>
                                <el-button type="text" @click="delAllHandle(item)" v-if="item.isOwner">删除</el-button>
                                <el-button type="text" @click="reply('主',item)" v-if="ruleForm.status !== 3">回复</el-button>
                                <div class="item-like" @click="likeHanlde(1,item)">
                                    <img src="@/assets/images/zan-no.png" alt="" v-if="!item.isLike">
                                    <img src="@/assets/images/zan-yi.png" alt="" v-if="item.isLike">
                                    <span class="item-title--count">{{item.likeCount}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="item-content">
                            {{item.content}}
                        </div>
                    </div>
                    <div class="main-item--right" v-if="item.detailsList.length>0">
                        <div class="right-item" v-for="items in item.detailsList" :key="items.id">
                            <div class="item-title">
                                <p>
                                    {{items.replyer}}（{{items.deptName}}）
                                    <span class="item-title--time">{{items.submitTime}}</span>
                                </p>
                                <div>
                                    <el-button type="text" v-if="items.isOwner" @click="delHandle(items)">删除</el-button>
                                    <el-button type="text" @click="reply('次',items)" v-if="ruleForm.status !== 3">回复</el-button>
                                    <div class="item-like" @click="likeHanlde(2,items)">
                                        <img src="@/assets/images/zan-no.png" alt="" v-if="!items.isLike">
                                        <img src="@/assets/images/zan-yi.png" alt="" v-if="items.isLike">
                                        <span class="item-title--count">{{items.likeCount}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="item-content">
                                回复<span v-if="items.respondent" class="item-content--name">{{items.respondent}}（{{items.respondentDeptName}}）</span>：{{items.content}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <opinion ref="opinion" @opinionEmit="opinionEmitHandle"></opinion>
        <el-dialog
            :visible="visiter"
            width="600px"
            title="回复"
            :before-close="cancelClick"
            :destroy-on-close="true"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-form :model="formData" ref="formData" :rules="rules" label-width="90px">
                <el-form-item label="回复内容：" prop="content">
                    <el-input 
                        type="textarea" 
                        v-model="formData.content"
                        maxlength="2000" 
                        show-word-limit 
                        :autosize="{ minRows: 8, maxRows: 8}"
                    ></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-btns">
                    <el-button @click="cancelClick">取消</el-button>
                    <el-button type="primary" @click="submit">确定</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import SectionTitle from './SectionTitle.vue';
import opinion from './opinion.vue';
import {
    apiApplicationDocumentlislistOpinionDetails,
    apiApplicationDocumentdeleteOpinion,
    apiApplicationDocumentdeleteOpinionResponse,
    apiApplicationDocumentreplyOpinionResponse,
    apiApplicationDocumenttoppingOpinion,
    apiApplicationDocumentcancelToppingOpinion,
    apiApplicationDocumentlikeOpinion,
    apiApplicationDocumentunlikeOpinion
} from '@/server/synthesize.js';
import { throttle, debounce } from "lodash";
export default {
    components: {
        SectionTitle,
        opinion
    },
    props: {
        ruleForm: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    data() {
        return {
            tableData: [],
            visiter: false,
            formData: {
                content: '',//回复内容
                documentGroupId: '',
                opinionId: '',
                parentId: ''
            },
            rules:{
                content: [
                    {required: true, message: '请输入回复内容', trigger: 'blur'}
                ],
            }
        }
    },
    methods: {
        apiApplicationDocumentlislistOpinionDetails() {
            apiApplicationDocumentlislistOpinionDetails({groupId:this.$parent.ruleForm.groupId}).then(({data}) => {
                if(data.code == '1') {
                    this.tableData = data.data || [];
                }
            })
        },
        issueOpinion() {//发表意见
            this.$refs.opinion.open({groupId:this.$parent.ruleForm.groupId});
        },
        reply(type,arg) {//回复
            this.visiter = true;
            this.formData = {
                content: '',//回复内容
                documentGroupId: '',
                opinionId: '',
                parentId: ''
            }
            if(type == '主') {
                this.formData.documentGroupId = arg.documentGroupId;
                this.formData.opinionId = arg.id;
                return;
            }
            if(type == '次') {
                this.formData.documentGroupId = arg.documentGroupId;
                this.formData.opinionId = arg.opinionId;
                this.formData.parentId = arg.id;
                return;
            }
        },
        submit:debounce(function() {//回复弹框提交
            this.$refs.formData.validate((valid) => {
                if(valid) {
                    apiApplicationDocumentreplyOpinionResponse(this.formData).then(({data}) => {
                        if(data.code == '1') {
                            this.$message.success('操作成功')
                            this.visiter = false;
                            this.apiApplicationDocumentlislistOpinionDetails();
                        }else {
                            this.$message.error(data.msg)
                        }
                    })
                }else {
                    return false;
                }
            })
        },1000,{
            leading: true,
            trailing: false
        }),
        delAllHandle(arg) {//意见汇总删除
            this.$confirm(`
                <div style="position:relative;bottom:-14px;margin-bottom:16px;">
                    <div style="font-size:18px;">确定要删除吗？</div>
                    <div style="margin-top:6px;">删除后对于本意见、回复的子回复将一并删除</div>
                </div>
            `,'提示',{
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.apiApplicationDocumentdeleteOpinion(arg)
            }).catch(() => {})
        },
        apiApplicationDocumentdeleteOpinion(arg) {//意见汇总删除接口
            apiApplicationDocumentdeleteOpinion({id:arg.id}).then(({data}) => {
                if(data.code == '1') {
                    this.$message.success('操作成功');
                    this.apiApplicationDocumentlislistOpinionDetails();
                }else {
                    this.$message.error(data.msg);
                }
            })
        },
        delHandle(arg) {//删除
            this.$confirm(`
                <div style="position:relative;bottom:-14px;margin-bottom:16px;">
                    <div style="font-size:18px;">确定要删除吗？</div>
                    <div style="margin-top:6px;">删除后对于本意见、回复的子回复将一并删除</div>
                </div>
            `,'提示',{
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                apiApplicationDocumentdeleteOpinionResponse({id:arg.id}).then(({data}) => {
                    if(data.code == '1') {
                        this.$message.success('操作成功');
                        this.apiApplicationDocumentlislistOpinionDetails();
                    }else {
                        this.$message.error(data.msg);
                    }
                })
            }).catch(() => {})
        },
        opinionEmitHandle() {
            this.apiApplicationDocumentlislistOpinionDetails();
        },
        cancelClick() {
            this.visiter = false;
        },
        topHandle:debounce(function(arg) {//置顶
            apiApplicationDocumenttoppingOpinion({id:arg.id}).then(({data}) => {
                if(data.code == '1') {
                    this.apiApplicationDocumentlislistOpinionDetails()
                }else {
                    this.$message.error(data.msg)
                }
            })
        },1000,{
            leading: true,
            trailing: false
        }),
        topNoHandle:debounce(function(arg) {//取消置顶
            apiApplicationDocumentcancelToppingOpinion({id:arg.id}).then(({data}) => {
                if(data.code == '1') {
                    this.apiApplicationDocumentlislistOpinionDetails()
                }else {
                    this.$message.error(data.msg)
                }
            })
        },1000,{
            leading: true,
            trailing: false
        }),
        likeHanlde:debounce(function(type,arg) {
            !arg.isLike && this.apiApplicationDocumentlikeOpinion(type,arg)
            arg.isLike && this.apiApplicationDocumentunlikeOpinion(type,arg)
        },1000,{
            leading: true,
            trailing: false
        }),
        apiApplicationDocumentlikeOpinion(type,arg) { //点赞接口
            apiApplicationDocumentlikeOpinion({
                documentId:arg.documentGroupId,
                messageType:type,
                messageId:arg.id
            }).then(({data}) => {
                if(data.code == '1') {
                    this.apiApplicationDocumentlislistOpinionDetails()
                }else {
                    this.$message.error(data.msg)
                }
            })
        },
        apiApplicationDocumentunlikeOpinion(type,arg) {//取消点赞接口
            apiApplicationDocumentunlikeOpinion({
                documentId:arg.documentGroupId,
                messageType:type,
                messageId:arg.id
            }).then(({data}) => {
                if(data.code == '1') {
                    this.apiApplicationDocumentlislistOpinionDetails()
                }else {
                    this.$message.error(data.msg)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.forum {
    min-height:130px;
    .forum-section {
        .forum-section--btn {
            text-align: center;
        }
        .section-main {
            margin-top: 20px;
            border: 1px solid #dcdfe6;
            padding: 20px;
            .section-main--item {
                border: 1px solid #1890FF;
                padding: 20px;
                border-radius: 5px;
                margin-bottom: 20px;
                &:last-child {
                    margin-bottom: 0;
                }
                .main-item--left {
                    .item-title {
                        display: flex;
                        justify-content: space-between;
                        font-size: 18px;
                        padding-right: 20px;
                        >div {
                            display: flex;
                            align-items: center;
                        }
                        p {
                            font-weight: bold;
                        }
                        .item-title--name {
                            display: inline-block;
                            max-width: 500px;
                            overflow: hidden;/*超出部分隐藏*/
                            text-overflow:ellipsis;/* 超出部分显示省略号 */
                            white-space: nowrap;/*规定段落中的文本不进行换行 */
                            vertical-align: middle;
                        }
                        .item-title--time {
                            font-weight: normal;
                            font-size: 16px;
                        }
                        .item-title--count {
                            display: inline-block;
                            width: 25px;
                            font-size: 14px;
                            color: #1890FF;
                            text-align: left;
                            margin-left: 6px;
                        }
                        .item-like {
                            cursor: pointer;
                            margin-left: 10px;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            &:hover {
                                opacity: .8;
                            }
                        }
                    }
                    .item-content {
                        line-height: 1.5;
                        word-break: break-all;
                    }
                }
                .main-item--right {
                    margin-top: 20px;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    .right-item {
                        padding: 20px;
                        border: 1px solid #dcdfe6;
                        width: 90%;
                        margin-bottom: 20px;
                        &:last-child {
                            margin-bottom: 0;
                        }
                        .item-title {
                            display: flex;
                            justify-content: space-between;
                            >div {
                                display: flex;
                                align-items: center;
                            }
                            p {
                                font-weight: bold;
                            }
                            .item-title--time {
                                font-weight: normal;
                            }
                            .item-title--count {
                                display: inline-block;
                                width: 25px;
                                color: #1890FF;
                                text-align: left;
                                margin-left: 6px;
                            }
                            .item-like {
                                cursor: pointer;
                                margin-left: 10px;
                                height: 100%;
                                display: flex;
                                align-items: center;
                                &:hover {
                                    opacity: .8;
                                }
                            }
                        }
                        .item-content {
                            line-height: 1.5;
                            padding-left: 50px;
                            word-break: break-all;
                            .item-content--name {
                                color: #aeaeae;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>